import type { PublicPropertySummary } from '@/lib/types/publicProperty';

export type MapCoordinates = { lat: number; lng: number };

const COORDINATES_BY_PROPERTY_CODE: Record<string, MapCoordinates> = {
  '460_richmond_w': { lat: 43.6478801, lng: -79.3977313 },
  '20_maud_st': { lat: 43.6466199, lng: -79.4000185 },
  '487_adelaide_w': { lat: 43.6456, lng: -79.400769 },
  '20_camden_st': { lat: 43.6473617, lng: -79.3969917 },
  '501_alliance_ave': { lat: 43.6766192, lng: -79.4887265 },
  '2_20_bradstock_ave': { lat: 43.7391634, lng: -79.5392472 },
  '3226_3228_weston_rd': { lat: 43.7388235, lng: -79.5395985 },
  '1080_1122_victoria_park': { lat: 43.7072471, lng: -79.2954802 },
};

export function resolveAvailabilityMapCoordinates(
  property: PublicPropertySummary,
): MapCoordinates | null {
  const explicit = readCoordinates(property);
  if (explicit) {
    return explicit;
  }

  const key = property.propertyCode.toLowerCase();
  return COORDINATES_BY_PROPERTY_CODE[key] ?? null;
}

function readCoordinates(source: unknown): MapCoordinates | null {
  const latitude =
    readFiniteNumber(source, 'latitude') ??
    readFiniteNumber(source, 'lat') ??
    readFiniteNumber(source, 'Latitude') ??
    readFiniteNumber(source, 'Lat');
  const longitude =
    readFiniteNumber(source, 'longitude') ??
    readFiniteNumber(source, 'lng') ??
    readFiniteNumber(source, 'lon') ??
    readFiniteNumber(source, 'Longitude') ??
    readFiniteNumber(source, 'Lng') ??
    readFiniteNumber(source, 'Lon');

  if (latitude === null || longitude === null) {
    return null;
  }

  return {
    lat: latitude,
    lng: longitude,
  };
}

function readFiniteNumber(source: unknown, key: string): number | null {
  if (source === null || typeof source !== 'object') {
    return null;
  }
  const record = source as Record<string, unknown>;
  const value = record[key];

  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string') {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
}
